export function rgbaIsSignatureInk(r: number, g: number, b: number, a: number): boolean {
  if (a === 0) return false;
  // White canvas background (#fff); strokes are near-black (#111).
  return r < 240 || g < 240 || b < 240;
}

export function imageDataHasSignatureInk(data: Uint8ClampedArray): boolean {
  for (let i = 0; i < data.length; i += 4) {
    if (rgbaIsSignatureInk(data[i]!, data[i + 1]!, data[i + 2]!, data[i + 3]!)) return true;
  }
  return false;
}
